
<template>
  <v-container>
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24"
    >
      <v-card-title class="text-h6 white--text">Key People</v-card-title>
      <v-card-subtitle class="white--text" align="start">
        This section provides three key resources to help you with anything
        related to the Referees App. Here you can contact the BQ Referee
        Development Manager for general coaching enquiries, BQ Support to
        technical assistance, and a link to find your local association on the
        BQ Website.
      </v-card-subtitle>
      <v-container>
        <v-row dense>
          <v-col cols="12">
            <v-card class="mt-2">
              <v-row>
                <v-card-title class="text-h5 ml-3">Alex McEwan</v-card-title>
                <v-avatar class="mt-3 ml-3">
                  <v-img src="../assets/AlexMcEwan.jpg"></v-img>
                </v-avatar>
              </v-row>
              <v-card-subtitle
                >Basketball Queensland Referee Development
                Manager</v-card-subtitle
              >

              <v-btn
                class="mb-2"
                color="oug"
                outlined
                elevation="24"
                @click="sendEmail(`referee@basketballqld.net.au`)"
                ><v-icon dark class="mr-2"> mdi-email-outline </v-icon>Contact
                Alex
              </v-btn>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card class="mt-2">
              <v-row>
                <v-card-title class="text-h5 ml-3"> BQ Support </v-card-title>
                <v-avatar class="mt-3 ml-3">
                  <v-img src="../assets/logo.png"></v-img>
                </v-avatar>
              </v-row>
              <v-card-subtitle
                >Tech Support for the Referee's App</v-card-subtitle
              >
              <Zendesk class="mb-3" title="Contact Support"/>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card class="mt-n1">
              <!-- <v-card color="oug" dark> -->
              <v-card-title class="text-h5"> Find an Association </v-card-title>

              <v-card-subtitle
                >Click the link below to search for your local
                association</v-card-subtitle
              >

              <v-btn
                class="mb-2"
                color="oug"
                outlined
                elevation="24"
                @click="
                  openDocument(`https://queensland.basketball/WheretoPlay.html`)
                "
                ><v-icon dark class="mr-2"> mdi-magnify </v-icon>
                Search Now
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Zendesk from "../common/Zendesk";

export default {
  components: {
    Zendesk,
  },
  data: () => ({}),
  methods: {
    sendEmail(email) {
      let wind_var = "mailto:" + email;
      window.open(wind_var, "_system");
    },
    phonePerson(phone) {
      let wind_var = "tel:" + phone.replace(/ /g, "");
      window.open(wind_var, "_system");
    },
    openDocument(url) {
      let file = url;
      window.open(file, "_system");
    },
  },
};
</script>